import { Box } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { memo } from "react";
import { SimulationModelsBehaviorEquity } from "./SimulationModelsBehaviorEquity";
import { SimulationModelsBehaviorCash } from "./SimulationModelsBehaviorCash";
import { SimulationModelsBehaviorFixedIncomeSpread } from "./SimulationModelsBehaviorFixedIncomeSpread";
import { CarAssetClassSelector } from "@app/components/AssetClassSelector";
import { SimulationModelsBehaviorInflation } from "./SimulationModelsBehaviorInflation";
import { CarPageContent } from "@app/components/PageContent";
import { CarPageContentCode, usePageContent } from "@app/hooks/usePageContent";
import { useSimulationAssetClassSelector } from "./useSimulationAssetClassSelector";
import { SimulationModelsBehaviorStaticFixedIncomeSpread } from "./SimulationModelsBehaviorStaticFixedIncomeSpread";
import { SimulationModelsBehaviorStaticCash } from "./SimulationModelsBehaviorStaticCash";
import { SimulationModelsBehaviorStaticEquity } from "./SimulationModelsBehaviorStaticEquity";
import { SimulationModelsBehaviorCommodity } from "./SimulationModelsBehaviorCommodity";

interface SimulationModelsBehaviorProps {
  isStatic: boolean;
}

export const SimulationModelsBehavior = memo(
  (props: SimulationModelsBehaviorProps) => {
    const assetClassSelector = useSimulationAssetClassSelector({
      includeInflationItem: true,
    });

    const pageContent = usePageContent();

    const acItem = assetClassSelector.selectedItem;

    const Component = (() => {
      if (!acItem) {
        return undefined;
      }
      if (acItem.isInflation) {
        return SimulationModelsBehaviorInflation;
      }

      if (props.isStatic) {
        if (acItem.isEquity || acItem.isGold) {
          return SimulationModelsBehaviorStaticEquity;
        }
        if (acItem.isFixedIncome) {
          return SimulationModelsBehaviorStaticFixedIncomeSpread;
        }
        if (acItem.isCash) {
          return SimulationModelsBehaviorStaticCash;
        }
      } else {
        if (acItem.isEquity || acItem.isGold) {
          return SimulationModelsBehaviorEquity;
        }
        if (acItem.isCommodity) {
          return SimulationModelsBehaviorCommodity;
        }
        if (acItem.isFixedIncome) {
          return SimulationModelsBehaviorFixedIncomeSpread;
        }
        if (acItem.isCash) {
          return SimulationModelsBehaviorCash;
        }

        console.log(
          `SimulationModelsBehavior: AC type is not identified`,
          acItem,
        );
      }
    })();

    return (
      <TablePlaceHolder
        sx={{ mt: 10 }}
        isLoading={assetClassSelector.isLoading || pageContent.isLoading}
        rows={8}
      >
        <CarPageContent
          sx={{ mb: 3 }}
          content={pageContent.getContent(
            CarPageContentCode.SIMULATION_ANALYSIS_MODELS_BEHAVIOR,
          )}
          isWhiteContext
        />
        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 5 }}>
          <CarAssetClassSelector
            sx={{
              width: 300,
              ".MuiInputBase-input": {
                backgroundColor: "white",
              },
            }}
            label="Selection"
            {...assetClassSelector}
          />
          {Component && acItem && <Component assetClassId={acItem.level4Id} />}
        </Box>
      </TablePlaceHolder>
    );
  },
);
